import React from "react";
import styled from "styled-components/macro";
import three_scooters_top_plan from "../../../images/ride/three_scooters_top_plan.png";
import four_scooters_top_plan from "../../../images/ride/four_scooters_top_plan.png";
import two_bike_top_plan from "../../../images/ride/two_bike_top.png";
import three_bike_top_plan from "../../../images/ride/three_bike_top.png";

const RideUnitTopPlan = (props) => {
  const myWidth = () => {
    if ("scooter" === props.type) {
      if (props.size === "large") {
        return 542.5;
      } else {
        return 434;
      }
    } else if ("bicycle" === props.type) {
      if (props.size === "large") {
        return 542.5;
      } else {
        return 434;
      }
    }
  };

  const getSpanMargin = () => {
    switch (props.type) {
      case "scooter":
        if (props.size === "large") {
          return { top: 41.5, right: -1.5 };
        }
        return { top: 42, right: -2.5 };
      case "bicycle":
        if (props.size === "large") {
          return { top: 45.5, right: 4 };
        }
        return { top: 45.5, right: -1 };
      default:
        break;
    }
  };

  const getImage = () => {
    switch (props.type) {
      case "scooter":
        if (props.size === "large") {
          return four_scooters_top_plan;
        }
        return three_scooters_top_plan;
      case "bicycle":
        if (props.size === "large") {
          return three_bike_top_plan;
        }
        return two_bike_top_plan;
      default:
        break;
    }
  };

  const getDepthBySize = () => {
    switch (props.type) {
      case "scooter":
        return 43.0;
      case "bicycle":
        return 65.0;
      default:
        break;
    }
  };

  return (
    <Wrapper>
      <Img src={getImage()} style={{ width: myWidth() }} />
      <DepthSpan margin={getSpanMargin()} size={props.size}>
        {props.location === "us"
          ? getDepthBySize().toFixed(2)
          : Math.ceil(getDepthBySize() * 2.54).toFixed(2)}
      </DepthSpan>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
`;

const Img = styled.img`
  // width:100%;
`;

const DepthSpan = styled.span`
  position: absolute;
  font-family: DMSans;
  font-size: 13px;
  top: 49%;
  left: 0;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.54;
  letter-spacing: normal;
  color: #6d6e6e;
  text-align: center;
`;

export default RideUnitTopPlan;
